import Vue from 'vue/dist/vue.js'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import zh from './locales/zh'
import { zh as supportZh, en as supportEn } from './support'
import { zh as landingZh, en as landingEn } from './landing'

Vue.use(VueI18n)

const messages = {
  en: { ...en, support: supportEn, landing: landingEn },
  zh: { ...zh, support: supportZh, landing: landingZh }
}

// Check browser language
const getBrowserLanguage = () => {
  try {
    const saved = window.localStorage.getItem('basboard.locale')
    if (saved === 'zh' || saved === 'en') return saved
  } catch (_) { /* Browser storage may be unavailable. */ }
  const language = navigator.language.toLowerCase()
  if (language.indexOf('zh') >= 0) {
    return 'zh'
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getBrowserLanguage(), // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
})

document.documentElement.lang = i18n.locale === 'zh' ? 'zh-CN' : 'en'

export default i18n
